import axios from 'axios';

const BASE_URL = '/pos';

export const signupUser = async (signupData) => {
  try {
    const response = await axios.post(`${BASE_URL}/authentication/register`, signupData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Signup failed');
  }
};

export const loginUser = async (loginData) => {
  try {
    const response = await axios.post(`${BASE_URL}/authentication/login`, loginData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Login failed');
  }
};

export const sendOtp = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/password/send-otp`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to send OTP');
  }
};

export const verifyOtp = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/password/verify-otp`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'OTP verification failed');
  }
};

export const resetPassword = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/password/reset`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Password reset failed');
  }
};
